import {
  getImageBase64,
  getBackground
  , getThemePic
} from "@/views/home/slidePPT/use/methods"
import {
  pathToBase64,
  isColor
} from '@/utils'

const nodule = async (data) => {
  const node = data.node;
  const color = data.color;
  const id = Math.random().toString(36).slice(-8);

  const background = await getBackground(data?.customTheme)

  return {
    id: id,
    elements: [
      {
        type: "shape",
        id: "B_cKtIoiSf",
        width: 38.91067913385827,
        height: 38.91067913385827,
        left: 37.31651902887139,
        top: 122.97211286089238,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
        opacity: 0.3,
      },
      {
        type: "shape",
        id: "aSuLq16FH3",
        width: 27.4441437007874,
        height: 27.4441437007874,
        left: 42.45685695538058,
        top: 128.62491797900262,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "gbwY3VB3cf",
        width: 17.29248687664042,
        height: 17.29248687664042,
        left: 75.59924540682415,
        top: 455.5903051181102,
        viewBox: [200, 200],
        path: "M 0 0 L 120 0 L 200 100 L 120 200 L 0 200 L 80 100 L 0 0 Z",
        fill: `${color}94`,
        fixedRatio: false,
        rotate: -90,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "l0xsPURJ0L",
        width: 17.29248687664042,
        height: 17.29248687664042,
        left: 75.59924540682415,
        top: 472.8827919947507,
        viewBox: [200, 200],
        path: "M 0 0 L 120 0 L 200 100 L 120 200 L 0 200 L 80 100 L 0 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: -90,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "text",
        id: "fDMRnHi6Jw",
        width: 190.74278215223097,
        height: 249.03125,
        left: 69.90100065616798,
        top: 187.9324967191601,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",

        fixedRatio: false,
        rotate: 0,
        content: `<p style="text-align: left;"><span style="font-size: 14.0625px;font-family: Microsoft Yahei;">${node.children[0].title || ""
          }${node.children[0].title ? "：" : ""}${node.children[0].text
          }</span></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333333",
      },
      {
        type: "shape",
        id: "ccWe3WxZQ-",
        width: 6.901820866141732,
        height: 6.901820866141732,
        left: 37.31651902887139,
        top: 29.14288057742782,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "hmKqyqXutd",
        width: 6.408874671916011,
        height: 6.408874671916011,
        left: 47.16609251968504,
        top: 28.90100065616798,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "DT1F_lcST7",
        width: 6.127296587926509,
        height: 6.127296587926509,
        left: 56.52271981627297,
        top: 29.041748687664043,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "YF5vOlAdOK",
        width: 5.678969816272966,
        height: 5.678969816272966,
        left: 65.5977690288714,
        top: 29.777477034120736,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "_ZZLWZ6ZN_",
        width: 5.38008530183727,
        height: 5.38008530183727,
        left: 74.22449146981627,
        top: 29.438484251968504,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "0doCzGEoRN",
        width: 6.901820866141732,
        height: 6.901820866141732,
        left: 37.31651902887139,
        top: 38.80282152230971,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "d_xy4WoyjG",
        width: 6.408874671916011,
        height: 6.408874671916011,
        left: 47.16609251968504,
        top: 38.560859580052494,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "GrH5ku_7CY",
        width: 6.127296587926509,
        height: 6.127296587926509,
        left: 56.52271981627297,
        top: 38.70168963254593,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "wMqtPekQqY",
        width: 5.678969816272966,
        height: 5.678969816272966,
        left: 65.5977690288714,
        top: 39.437417979002625,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "eGJyw5ztj7",
        width: 5.38008530183727,
        height: 5.38008530183727,
        left: 74.22449146981627,
        top: 39.09842519685039,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "XRmB6aEwLf",
        width: 6.901820866141732,
        height: 6.901820866141732,
        left: 37.31651902887139,
        top: 48.4627624671916,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "kEdOJ13SmT",
        width: 6.408874671916011,
        height: 6.408874671916011,
        left: 47.16609251968504,
        top: 48.22080052493438,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "YCrGRXdjLv",
        width: 6.127296587926509,
        height: 6.127296587926509,
        left: 56.52271981627297,
        top: 48.36154855643044,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "Jo3COL6jnJ",
        width: 5.678969816272966,
        height: 5.678969816272966,
        left: 65.5977690288714,
        top: 49.09727690288714,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "KPULQNDnfv",
        width: 5.38008530183727,
        height: 5.38008530183727,
        left: 74.22449146981627,
        top: 48.758284120734906,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "MPEj-B8hHc",
        width: 6.901820866141732,
        height: 6.901820866141732,
        left: 37.31651902887139,
        top: 58.122621391076116,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "adnnofHDOM",
        width: 6.408874671916011,
        height: 6.408874671916011,
        left: 47.16609251968504,
        top: 57.88074146981627,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "wA7ksfcGUe",
        width: 6.127296587926509,
        height: 6.127296587926509,
        left: 56.52271981627297,
        top: 58.02148950131234,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "scAQBOebmm",
        width: 5.678969816272966,
        height: 5.678969816272966,
        left: 65.5977690288714,
        top: 58.75721784776903,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "yKQqSSbNlY",
        width: 5.38008530183727,
        height: 5.38008530183727,
        left: 74.22449146981627,
        top: 58.418225065616795,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "text",
        id: "9X28JQwVSg",
        width: 820.500997375328,
        height: 57.5,
        left: 89.74950131233598,
        top: 29.14288713910761,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",

        fixedRatio: false,
        rotate: 0,
        content: `<p style="text-align: left;"><strong><span style="font-size: 25px;font-family: Microsoft Yahei;">${node.title || ""
          }</span></strong></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333333",
      },
      {
        type: "shape",
        id: "IVNSH-8O7r",
        width: 38.91067913385827,
        height: 38.91067913385827,
        left: 269.90748031496065,
        top: 122.97211286089238,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
        opacity: 0.3,
      },
      {
        type: "shape",
        id: "yCsPWi-b1z",
        width: 27.4441437007874,
        height: 27.4441437007874,
        left: 275.0478182414698,
        top: 128.62491797900262,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "_JJAfsO82o",
        width: 17.29248687664042,
        height: 17.29248687664042,
        left: 308.19020669291336,
        top: 455.5903051181102,
        viewBox: [200, 200],
        path: "M 0 0 L 120 0 L 200 100 L 120 200 L 0 200 L 80 100 L 0 0 Z",
        fill: `${color}94`,
        fixedRatio: false,
        rotate: -90,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "Gt_6lL4yA4",
        width: 17.29248687664042,
        height: 17.29248687664042,
        left: 308.19020669291336,
        top: 472.8827919947507,
        viewBox: [200, 200],
        path: "M 0 0 L 120 0 L 200 100 L 120 200 L 0 200 L 80 100 L 0 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: -90,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "text",
        id: "4cw84OPmKj",
        width: 190.74278215223097,
        height: 249.03125,
        left: 308.8181594488189,
        top: 187.9324967191601,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",

        fixedRatio: false,
        rotate: 0,
        content: `<p style="text-align: left;"><span style="font-size: 14.0625px;font-family: Microsoft Yahei;">       ${node.children[1].title || ""
          }${node.children[1].title ? "：" : ""}${node.children[1].text
          }</span></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333333",
      },
      {
        type: "shape",
        id: "r7aaUyS4XS",
        width: 38.91067913385827,
        height: 38.91067913385827,
        left: 502.4984416010499,
        top: 122.97211286089238,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
        opacity: 0.3,
      },
      {
        type: "shape",
        id: "DUhMz8PJRb",
        width: 27.4441437007874,
        height: 27.4441437007874,
        left: 507.63877952755905,
        top: 128.62491797900262,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "_B2jGfps1Y",
        width: 17.29248687664042,
        height: 17.29248687664042,
        left: 540.78125,
        top: 455.5903051181102,
        viewBox: [200, 200],
        path: "M 0 0 L 120 0 L 200 100 L 120 200 L 0 200 L 80 100 L 0 0 Z",
        fill: `${color}94`,
        fixedRatio: false,
        rotate: -90,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "Yxt3cTht-v",
        width: 17.29248687664042,
        height: 17.29248687664042,
        left: 540.78125,
        top: 472.8827919947507,
        viewBox: [200, 200],
        path: "M 0 0 L 120 0 L 200 100 L 120 200 L 0 200 L 80 100 L 0 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: -90,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "text",
        id: "tjCzU6xxh1",
        width: 190.74278215223097,
        height: 249.03125,
        left: 541.4091207349081,
        top: 187.9324967191601,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",

        fixedRatio: false,
        rotate: 0,
        content: `<p style="text-align: left;"><span style="font-size: 14.0625px;font-family: Microsoft Yahei;">       ${node.children[2].title || ""
          }${node.children[2].title ? "：" : ""}${node.children[2].text
          }</span></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333333",
      },
      {
        type: "shape",
        id: "U-eU6ctrvJ",
        width: 38.91067913385827,
        height: 38.91067913385827,
        left: 735.089402887139,
        top: 122.97211286089238,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
        opacity: 0.3,
      },
      {
        type: "shape",
        id: "YWfVKrODmC",
        width: 27.4441437007874,
        height: 27.4441437007874,
        left: 740.2298228346457,
        top: 128.62491797900262,
        viewBox: [200, 200],
        path: "M 100 0 A 50 50 0 1 1 100 200 A 50 50 0 1 1 100 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: 0,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "IkcBtx4ekc",
        width: 17.29248687664042,
        height: 17.29248687664042,
        left: 773.3722112860893,
        top: 455.5903051181102,
        viewBox: [200, 200],
        path: "M 0 0 L 120 0 L 200 100 L 120 200 L 0 200 L 80 100 L 0 0 Z",
        fill: `${color}94`,
        fixedRatio: false,
        rotate: -90,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "shape",
        id: "LwgolQPgya",
        width: 17.29248687664042,
        height: 17.29248687664042,
        left: 773.3722112860893,
        top: 472.8827919947507,
        viewBox: [200, 200],
        path: "M 0 0 L 120 0 L 200 100 L 120 200 L 0 200 L 80 100 L 0 0 Z",
        fill: `${color}`,
        fixedRatio: false,
        rotate: -90,
        text: {
          content: "",
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "middle",
        },
      },
      {
        type: "text",
        id: "7S-OPnX-Wj",
        width: 190.74278215223097,
        height: 249.03125,
        left: 774.0000820209974,
        top: 187.9324967191601,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",

        fixedRatio: false,
        rotate: 0,
        content: `<p style="text-align: left;"><span style="font-size: 14.0625px;font-family: Microsoft Yahei;">       ${node.children[3].title || ""
          }${node.children[3].title ? "：" : ""}${node.children[3].text
          }</span></p>`,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333333",
      },
      {
        type: "line",
        id: "s7HjfIE1k-",
        width: 0.75,
        left: 55.485810367454064,
        top: 146.99146981627297,
        start: [0, 0],
        end: [0, 343.4782644356955],
        style: "dashed",
        color: `${color}`,
        points: ["", ""],
      },
      {
        type: "line",
        id: "KBpuwzR-Kt",
        width: 0.75,
        left: 288.0767716535433,
        top: 146.99146981627297,
        start: [0, 0],
        end: [0, 343.4782644356955],
        style: "dashed",
        color: `${color}`,
        points: ["", ""],
      },
      {
        type: "line",
        id: "lqkzl0ymE7",
        width: 0.75,
        left: 520.6677329396325,
        top: 146.99146981627297,
        start: [0, 0],
        end: [0, 343.4782644356955],
        style: "dashed",
        color: `${color}`,
        points: ["", ""],
      },
      {
        type: "line",
        id: "mliRk2WCna",
        width: 0.75,
        left: 753.2586942257218,
        top: 146.99146981627297,
        start: [0, 0],
        end: [0, 343.4782644356955],
        style: "dashed",
        color: `${color}`,
        points: ["", ""],
      },
    ],
    background
  };
};
export default nodule;
